import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import FeaturedJobFavoriteButton from '~/components/button/featured-job-favorite-button';
import { JobDetail } from '~/types/job-detail';

interface FeaturedJobProps {
  job: JobDetail;
  gtmClass?: string;
  refParam?: string;
  favoriteJobIds: number[];
  isMobile: boolean;
  isSignedIn: boolean;
}

const truncate = (text: string, maxLength: number): string => {
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

const FeaturedJob: React.FC<FeaturedJobProps> = ({
  job,
  gtmClass = '',
  refParam = '',
  favoriteJobIds,
  isMobile,
  isSignedIn,
}) => {
  // refParam が存在する場合のみクエリ文字列を追加
  const queryString = refParam ? `?ref=${encodeURIComponent(refParam)}` : '';

  // 画像表示用：job.image.w600.url が存在するかどうかで分岐
  const imageUrl =
    job.image && job.image.w600 && job.image.w600.url
      ? job.image.w600.url
      : `/nextjs/images/sample_images/image${(job.id % 9) + 1}_small.webp`;

  return (
    <div className="p-featured-jobs__item">
      {!isMobile && (
        <Link
          href={`/jobs/${job.id}${queryString}`}
          className={`p-featured-jobs__image-wrap ${gtmClass}`}
          prefetch={false}
        >
          <img
            src={imageUrl}
            alt={job.title}
            style={{ width: '100%' }}
            className="p-featured-jobs__image"
            loading="lazy"
          />
        </Link>
      )}
      <Link
        href={`/jobs/${job.id}${queryString}`}
        className={`p-featured-jobs__item-wrapper ${gtmClass}`}
        prefetch={false}
      >
        {job.display_company_info ? (
          <div className="p-featured-jobs__item__company">
            {job.company?.name}
          </div>
        ) : (
          <div className="p-featured-jobs__item__company">社名非公開</div>
        )}
        <div className="p-featured-jobs__item__title">
          {truncate(job.title, 30)}
        </div>
        <div className="p-featured-jobs__item__info">
          <div style={{ display: 'flex' }}>
            <img
              src="/nextjs/images/icons/ic_bag.svg"
              width={15}
              height={15}
              loading="lazy"
              alt="bag icon"
            />
            <span>
              {job.categories && job.categories.length > 0
                ? truncate(job.categories[0]?.name, 8)
                : ''}
            </span>
          </div>
          <div style={{ display: 'flex' }}>
            <img
              src="/nextjs/images/icons/ic_location.svg"
              width={15}
              height={15}
              loading="lazy"
              alt="location icon"
            />
            <span>{job.prefecture?.name}</span>
          </div>
        </div>
        {job.annual_salary && (
          <div className="p-featured-jobs__item__conditions">
            <img
              src="/nextjs/images/icons/ic_money.svg"
              width={15}
              height={15}
              loading="lazy"
              alt="money icon"
            />
            <span>
              {job.annual_salary.split('万円')[0]}
              {job.annual_salary.split('万円')[0] && (
                <span className="u-color-black u-fs12">万円</span>
              )}
            </span>
          </div>
        )}
      </Link>
      <FeaturedJobFavoriteButton
        job={job}
        favoriteJobIds={favoriteJobIds}
        isSignedIn={isSignedIn}
      />
    </div>
  );
};

export default FeaturedJob;
